import { AutomaticUserState } from 'src/models/userState';

import { Callback } from 'src/util/query/models/Callback';

export class GetAutomaticUserStatesCallBack extends Callback<AutomaticUserState[]> {
	public constructor(
		private readonly setAutomaticUserStates: (automaticUserStates: Array<AutomaticUserState>) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: AutomaticUserState[]): void => {
		this.setAutomaticUserStates(successResponse);
	};
}
